import "./assets/scss/hope-ui.scss"
import "./assets/scss/custom.scss"
import "./assets/scss/dark.scss"
import "./assets/scss/rtl.scss"
import "./assets/scss/customizer.scss"
import "./assets/custom/css/custom.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import { useState, useEffect } from "react"
import AsyncStorage from '@react-native-async-storage/async-storage';
import { USER_ROLES } from './utilities/constant';

import { useDispatch } from 'react-redux';
import { setSetting } from './store/setting/actions'

import FloatingPanels from "./views/dashboard/desposition/FloatingPanels";
import { FloatingPanelProvider } from "./views/dashboard/desposition/useFloatingPanelState";

function App({ children }) {
  const [isCallCentreAgent, setIsCallCenterAgent] = useState(false);
  const dispatch = useDispatch();
  dispatch(setSetting());

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = await AsyncStorage.getItem("user");

      if (!rawUser) {
        console.error("User data not found in AsyncStorage");
        return;
      }

      try {
        const user = JSON.parse(rawUser);
        setIsCallCenterAgent(user?.role === USER_ROLES.CALL_CENTRE_AGENT);
      } catch (e) {
        console.error("Invalid JSON in AsyncStorage user:", e);
      }
    };
    fetchUserData();
  }, []);

  return (
    <FloatingPanelProvider> 
    <ToastContainer 
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
      <div className="App">
        {children}
        {/* {isCallCentreAgent && <FloatingPanels />} */}
      </div>
    </FloatingPanelProvider>
  );
}

export default App;
